import { AssetSheetDerivedRowStatus } from '@atlas/types'
import type { LastSync } from '@/hooks/useAssetSheet'

/** The page's tabs, as `?tab=` names them. */
export enum AssetSheetView {
	OVERVIEW = 'overview',
	ROWS = 'rows',
	COLUMN_MAP = 'column-map',
}

/** The query parameters the page keeps its state in, so a view can be linked and survives a reload. */
export enum AssetSheetParam {
	VIEW = 'tab',
	/** The workbook tab, shared by the Rows filter and the column map's tab selector. */
	SHEET_TAB = 'sheetTab',
	STATUS = 'status',
	/** Part of an asset code. */
	QUERY = 'q',
	PAGE = 'page',
}

/** A link target opening one view of the page with the given parameters. */
export function viewSearch(view: AssetSheetView, params: Partial<Record<AssetSheetParam, string>> = {}): string {
	const search = new URLSearchParams({ [AssetSheetParam.VIEW]: view })
	for (const [key, value] of Object.entries(params)) if (value) search.set(key, value)
	return `?${search}`
}

const STATUSES = new Set<string>(Object.values(AssetSheetDerivedRowStatus))

/** The status filter in the URL, or undefined when it names no status. */
export const statusOf = (value: string | null): AssetSheetDerivedRowStatus | undefined =>
	value && STATUSES.has(value) ? (value as AssetSheetDerivedRowStatus) : undefined

/** A completed sync's row counts, as the page and its notifications say them. */
export const describeSyncCounts = ({ created, changed, blocked, removed }: NonNullable<LastSync['counts']>) =>
	`${created} new, ${changed} changed, ${blocked} blocked, ${removed} removed rows`
